import { render, staticRenderFns } from "./PostFitOutNextReviewer.vue?vue&type=template&id=c584ba92&scoped=true&"
import script from "./PostFitOutNextReviewer.vue?vue&type=script&lang=js&"
export * from "./PostFitOutNextReviewer.vue?vue&type=script&lang=js&"
import style0 from "./PostFitOutNextReviewer.vue?vue&type=style&index=0&id=c584ba92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c584ba92",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c584ba92')) {
      api.createRecord('c584ba92', component.options)
    } else {
      api.reload('c584ba92', component.options)
    }
    module.hot.accept("./PostFitOutNextReviewer.vue?vue&type=template&id=c584ba92&scoped=true&", function () {
      api.rerender('c584ba92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenantProjects/postFitOutLetter/PostFitOutNextReviewer.vue"
export default component.exports